import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class ActionReasonsAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // CREATE //
  createSuccess() {
    const message = {
      body: 'ACTION_REASON_CREATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  createError() {
    const message = {
      body: 'ACTION_REASON_CREATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'ACTION_REASON_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'ACTION_REASON_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  removeSuccess() {
    const message = {
      body: 'ACTION_REASON_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeError() {
    const message = {
      body: 'ACTION_REASON_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.action-reasons')
  .service('actionReasonsAlertsService', ActionReasonsAlertsService);
